// eslint-disable-next-line import/no-anonymous-default-export
export default (asset = [], action) => {
  switch (action.type) {
    case "FETCH_ALL_ASSET":
      return action.payload;

    case "CREATE_ASSET":
      return [...asset, action.payload];

    case "TRANSFER_ASSET": {
      const updated = action.payload?.data || action.payload;
      // merge, so the row keeps its worked-out figures (depreciation etc.)
      return asset.map((a) =>
        (a?._id || a?.id) === (updated?._id || updated?.id)
          ? { ...a, ...updated }
          : a,
      );
    }

    default:
      return asset;
  }
};
